import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Joi from "@hapi/joi";
import get from "lodash/get";
import { bindActionCreators } from "redux";
import "./index.css";
import DynamicForm from "Component/DynamicForm";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { ErrorMessages } from "Constants";
import { instance } from "Actions/AxiosInstance";
import { isSpaceInString } from "Utils";


const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  drawerPaper: {
    width: "30%",
  },
});

class Define extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: 0,
      fbpname: "",
      description: "",
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
    });
  }

  onSubmit() {
    const data = this.props.postData;
    const schema = Joi.object().keys({
      fbpname: Joi.string()
        .required()
        .label("E1000"),
    });
    const { error } = schema.validate({ fbpname: data.fbpname });

    if (data.fbpname && !isSpaceInString(data.fbpname)) {
      data.fbpname = data.fbpname.trim();
    } 

    if (error) {
      this.props.enqueueSnackbar(ErrorMessages[get(error, "details[0].context.label", "err")], {
        variant: "error",
      });
    } else if (data.fbpname) {
      instance.post("payroll/uniquefbpnamecheck", {
        fbpname: data.fbpname,
        subscriptionfbpid: data.subscriptionfbpid,
      }).then(() => {
        this.props.onNextClick();
      }).catch((error1) => {
        this.props.enqueueSnackbar(
          error1.response ? error1.response.data.error.message : error1.message,
          { variant: "error" },
        );
      });
    } else {
      this.props.onNextClick();
    }
  }

  handleChange(value, key) {
    const { postData } = this.props;
    postData[key] = value;
    this.setState({
      [key]: value,
    });
    this.props.updatePostData(postData);
  }

  render() {
    console.log('this.props.editableKey: ', this.props.editableKey);
    const { postData } = this.props;
    return (
      <IntlProvider locale="en" messages={""}>
        <div className="stepper-scroller padding-top-0">
          <div className="stepper-scroller-content">
            <div className="width100">
              <DynamicForm
                fields={textinputconverter({
                  value: postData && postData.fbpname,
                  placeholder: "Enter plan name",
                  label: "Flexible plan name",
                  disabled: this.props.editableKey ? false : true,
                })}
                onChange={(value) => {
                  this.handleChange(value, "fbpname");
                }}
              />
            </div>
            <div className="padding-bottom-30 width100">
              <DynamicForm
                className="width50"
                fields={textareainputconverter({
                  value: postData && postData.description,
                  placeholder: "Enter description",
                  label: "Description",
                  disabled: this.props.editableKey ? false : true,
                })}
                onChange={(value) => {
                  this.handleChange(value, "description");
                }}
              />
            </div>
                {/* <div
                  className="form-group width497"
                  style={{ background: "#f7f8f8" }}
                >
                  <p className="input-label">
                    Eligible employees configuration
                  </p>
                  <div>
                    <Select
                      className="width497"
                      // ref={(r) => { this.firstElement = r; }}
                      // onChange={this.UpdateSelectedDropdownItem.bind(this, "addresstypeid", "HtAddressType")}
                      // options={this.state.addressType}
                      // getOptionLabel={(option) => option.displayname}
                      // getOptionValue={(option) => option.displayvalue}
                      // value={this.state.selectedAddressType}
                      // isDisabled={this.state.employeeaddressid}
                      placeholder="Select configuration"
                    />
                  </div>
                  <div style={{ margin: "8px 0px" }}>
                    <p className="input-label">Location</p>
                    <Select
                      className="width497"
                      // ref={(r) => { this.firstElement = r; }}
                      // onChange={this.UpdateSelectedDropdownItem.bind(this, "addresstypeid", "HtAddressType")}
                      // options={this.state.addressType}
                      // getOptionLabel={(option) => option.displayname}
                      // getOptionValue={(option) => option.displayvalue}
                      // value={this.state.selectedAddressType}
                      // isDisabled={this.state.employeeaddressid}
                      placeholder="Select "
                    />
                  </div>
                  <div style={{ margin: "8px 0px" }}>
                    <Grid container>
                      <Grid item md={6} xs={12} sm={12} lg={6}>
                        <p className="input-label">Description</p>
                        <TextField
                          id="outlined-dense"
                          margin="dense"
                          variant="outlined"
                          className="width90"
                          style={{ background: "white" }}
                          // onChange={(e) => this.handleChange("description", e.target.value)}
                          // value={selectedPolicy.description}
                        />
                      </Grid>
                      <Grid item md={6} xs={12} sm={12} lg={6}>
                        <p className="input-label" style={{ marginLeft: 22 }}>
                          Description
                        </p>
                        <TextField
                          id="outlined-dense"
                          margin="dense"
                          variant="outlined"
                          className="floatright width90"
                          style={{ background: "white" }}
                          // onChange={(e) => this.handleChange("description", e.target.value)}
                          // value={selectedPolicy.description}
                        />
                      </Grid>
                    </Grid>
                  </div>
                </div>
                <div className="form-group">
                  <p className="input-label">Assign to salary structure</p>
                  <Select
                    className="width497"
                    // ref={(r) => { this.firstElement = r; }}
                    // onChange={this.UpdateSelectedDropdownItem.bind(this, "addresstypeid", "HtAddressType")}
                    // options={this.state.addressType}
                    // getOptionLabel={(option) => option.displayname}
                    // getOptionValue={(option) => option.displayvalue}
                    // value={this.state.selectedAddressType}
                    // isDisabled={this.state.employeeaddressid}
                    placeholder="Select "
                  />
                </div> */}
          </div>
        </div>
      </IntlProvider>
    );
  }
}
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(Define)));
